/**
 * <strong>Properties:</strong><br>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DescriptionMixin|description}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DisabledMixin|disabled}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/EditableMixin|editable}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/HorizontalAlignmentMixin|horizontalAlignment}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/PlaceholderMixin|placeholder}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/SizeMixin|width, height}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TagMixin|tag}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TextInputValueMixin|value}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ValidationMixin|validationState, errorText, warningText}</li>
 * <br>
 * <br>
 * <strong>Events:</strong>
 * <br>
 * <br>
 * <li>{@link module:mw-form/mixins/event/ChangeEventMixin|change}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/event/TypingEventMixin|typing}</li>
 * <br>
 * <br>
 * <strong>Example:</strong>
 * <br>
 * <br>
 * For a working example, see the {@link http://inside-files/dev/eps/WIT/WebWidgets/Gallery/Gallery/#textarea_anchor|gallery}
 * <br>
 * <br>
 * @module mw-form/TextArea
 *
 * @copyright Copyright 2015-2016 The MathWorks, Inc.
 */

// TODO: Remove _CSSStateMixin dependency, as seen in SplitButton and ToggleSplitButton

define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "dijit/_Contained",
    "dijit/_CssStateMixin",
    "dijit/_FocusMixin",
    "dijit/_TemplatedMixin",

    //Custom Mixins
    "mw-form/mixins/property/TagMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "mw-form/mixins/property/DisabledMixin",
    "mw-form/mixins/property/HorizontalAlignmentMixin",
    "mw-form/mixins/property/EditableMixin",
    "mw-form/mixins/property/SizeMixin",
    "mw-form/mixins/property/TextInputValueMixin",
    "mw-form/mixins/SharedTextInputMixin",
    "mw-form/mixins/property/PlaceholderMixin",
    "mw-form/mixins/property/VisualFamilyMixin",
    "mw-form/mixins/property/ValidationMixin",

    //events
    "mw-form/mixins/event/ChangeEventMixin",
    "mw-form/mixins/event/TypingEventMixin",
    "mw-form/mixins/mixinDependencyValidator",

    //Template
    "dojo/text!./templates/TextArea.html"

], function (declare, _WidgetBase, _Contained, _CssStateMixin, _FocusMixin, _TemplatedMixin, TagMixin, DescriptionMixin,
             DisabledMixin, HorizontalAlignmentMixin, EditableMixin, SizeMixin, TextInputValueMixin,
             SharedTextInputMixin, PlaceholderMixin, VisualFamilyMixin, ValidationMixin, ChangeEventMixin, TypingEventMixin, mixinDependencyValidator, template){


    return declare(mixinDependencyValidator.validate([_WidgetBase, _Contained, _CssStateMixin, _FocusMixin, _TemplatedMixin, TagMixin, DescriptionMixin,
        DisabledMixin, HorizontalAlignmentMixin, EditableMixin, SizeMixin,
        TextInputValueMixin, SharedTextInputMixin, PlaceholderMixin, VisualFamilyMixin, ValidationMixin, ChangeEventMixin, TypingEventMixin]), {

        baseClass: "mwWidget mwTextArea",
        templateString: template,

        /* overriding default value of Horizontal Alignment Mixin */
        horizontalAlignment: "left",

        /* overriding the values of size mixin */
        width: 150,
        height: 66,

        _setDisabledAttr: function (disabled) {
            this.inherited(arguments);
            if(disabled === true) {
                this.inputNode.setAttribute("disabled", "");
            } else {
                this.inputNode.removeAttribute("disabled");
            }
        }

    });

});